module.exports = __webpack_public_path__ + "static/tanoto-sm-detail-09acd49d315a4390af707ef5ec9e77cb.jpg";